import {  EntityType } from '@lib/deals';


export function toForm(
  { relation, person, company_name, source_links, ...deal }: any,
  appendEmpty = true,
) {
  return {
    ...deal,
    buyers: relation
      ? [
          {
            vtr_id: relation?.company_vtr_id,
            type: EntityType.company,
            name: company_name,
            meta: relation,
            relation_type: 'buyer',
            order_id: 1,
          },
        ]
      : appendEmpty
        ? [
            {
              vtr_id: '',
              type: EntityType.company,
              name: company_name,
              meta: null,
              relation_type: 'buyer',
              order_id: 1,
            },
          ]
        : [],
    associated_person: person
      ? [
          {
            vtr_id: person?.vtr_id,
            type: EntityType.person,
            name: person?.name,
            markets_responsible: relation?.markets_responsible || '',
            meta: {
              ...person,
              currently_working: relation?.currently_working,
              designation: relation?.designation || '',
              markets_responsible: relation?.markets_responsible || '',
            },
            relation_type: 'person',
            order_id: 1,
          },
        ]
      : appendEmpty
        ? [
            {
              vtr_id: '',
              type: EntityType.person,
              name: company_name,
              meta: null,
              relation_type: 'person',
              order_id: 1,
            },
          ]
        : [],
/*     currently_working: relation?.currently_working || '',
    designation: relation?.designation || '', */
    description: relation?.description || '',
    sources: relation?.source_links || '',
  };
}


export function fromForm({
  buyers,
  associated_person,
  description,
  sources,
  ...deal
}): any {
  // Assign entitiy values
  deal.buyers = buyers
    .filter(e => e)
    .filter(e => e.name)
    .map((e, idx) => (delete e['meta'], e));
  let firstNonBookFound = false;
 
  if (associated_person) {
    deal.associated_person = setAssociatedPersonName(associated_person);
  }else {
    deal.associated_person = []
  }
  deal.description = description ?? ""
  deal.sources = sources ?? ""
  return deal ;
}


function setAssociatedPersonName(associated_person) {
  let requiredAssociatedPerson = [];
  if (associated_person) {
    requiredAssociatedPerson = associated_person.map(x => {
      if (typeof x === 'string') {
        return {
          name: x,
          vtr_id: '',
          designation: '',
          company: '',
          company_vtr_id: '',
          relation_type:'',
          type:'',
          order_id: 1,
          person_vtr_id:''
        };
      } 
      else if(x.meta){
        return {
          name: x?.name,
          vtr_id: x?.vtr_id,
  // ✅ ALWAYS prioritize direct form values
          currently_working: x?.currently_working ?? x?.meta?.currently_working ?? "",
          designation: x?.designation ?? x?.meta?.designation ?? "",
          markets_responsible: x?.markets_responsible ?? x?.meta?.markets_responsible ?? "",
          company: x?.meta?.selectedCompany?.company_vtr_id,
          company_vtr_id: x?.meta?.selectedCompany?.company_vtr_id,
          company_name: x?.meta?.selectedCompany?.company_name === "No Company" ? x?.meta?.selectedCompany?.company_name : "",
          relation_type:'person',
          type:'PERSON',
          order_id: 1,
          person_vtr_id: x?.meta?.selectedCompany?.person_vtr_id,
        };
      }
      else {
        return {
          name: x.name,
          vtr_id: x.vtr_id,
          designation: x.designation ? x.designation : "",
          currently_working:x?.currently_working ? x?.currently_working : "",
          markets_responsible: x?.markets_responsible ?? x?.meta?.markets_responsible ?? "",
          company: x.company,
          company_vtr_id: x.company,
          company_name: x.company_name === "No Company" ? "" : x.company_name,
          relation_type:'person',
          type:'PERSON',
          order_id: 1,
          person_vtr_id: x.person_vtr_id,
          
        };
      }
    });
  }
  return requiredAssociatedPerson.filter((person) => person !== null);
}